import { render, staticRenderFns } from "./PreviewColumns.vue?vue&type=template&id=4c311343&scoped=true&"
import script from "./PreviewColumns.vue?vue&type=script&lang=js&"
export * from "./PreviewColumns.vue?vue&type=script&lang=js&"
import style0 from "./PreviewColumns.vue?vue&type=style&index=0&id=4c311343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c311343",
  null
  
)

export default component.exports